<template>
	<CCard>
		<CCardHeader><h5>Informations sur la réclamation</h5></CCardHeader>
		<CCardBody>
			<div class="form-group">
				<label>Raison du litige</label>
				<GTreeView
					input-name="complaintReason"
					label="Raison du litige"
					placeholder="Recherchez une raison de litige"
					label-prop="text"
					:multiple="false"
					fetch-url="/api/complaint_reasons?itemsPerPage=100" />
			</div>
			<CSelect label="Moyen de contact" :options="contactOptions" name="contactChannel" />
		</CCardBody>
	</CCard>
</template>

<script>
	import GTreeView from '../../../../../components/ghostlexly-components/GTreeView';

	export default {
		name: 'TicketInfoCard',
		components: { GTreeView },
		data: function () {
			return {
				contactOptions: [
					{
						label: 'Téléphone',
						value: 'support_ticket.contact_channel.phone',
					},
					{
						label: 'E-mail',
						value: 'support_ticket.contact_channel.email',
					},
					{
						label: 'Internet',
						value: 'support_ticket.contact_channel.web',
					},
					{
						label: 'Lettre',
						value: 'support_ticket.contact_channel.letter',
					},
				],
			};
		},
	};
</script>
